module.exports = __webpack_public_path__ + "static/media/tokens.ef1c6260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tokens.svg
// module id = 307
// module chunks = 25